import "../styles/Layout.css";
import contractArtifact from "../contracts/PromptMeister.json";
import { Link } from "react-router-dom";
import logo from "../images/pmlogo1.png";
import { ethers } from "ethers";
import React, { createContext, useContext, useState, useEffect } from "react";

export const EthereumContext = createContext();

function Layout({ children, gradientStart, gradientEnd }) {
  let [isConnected, setIsConnected] = useState(false);
  let [userAccount, setUserAccount] = useState(null);
  let [walletProvider, setWalletProvider] = useState(null);
  let [signer, setSigner] = useState(null);
  let [contract, setContract] = useState(null);

  useEffect(() => {
    // This code will run once when the component mounts
    const initializeContract = async () => {
      if (!signer && window.ethereum != null) {
        // Only initialize the contract if there's no signer

        const chainId = await window.ethereum.request({
          method: "eth_chainId",
        });
        if (chainId === "0x13881") {
          try {
            setContract(
              new ethers.Contract(
                contractArtifact.address,
                contractArtifact.abi,
                new ethers.JsonRpcProvider(contractArtifact.rpcUrl)
              )
            );
          } catch (addError) {
            console.log(addError);
          }
        }
      } else if (!signer && window.ethereum == null) {
        try {
          setContract(
            new ethers.Contract(
              contractArtifact.address,
              contractArtifact.abi,
              new ethers.JsonRpcProvider(contractArtifact.rpcUrl)
            )
          );
        } catch (addError) {
          console.log(addError);
        }
      }
    };

    initializeContract();
  }, []); // Empty dependency array means this runs once on mount
  const connectWallet = async () => {
    if (window.ethereum == null) {
      console.log("Wallet not detected!");
    } else {
      try {
        const chainId = await window.ethereum.request({
          method: "eth_chainId",
        });
        console.log(chainId);
        if (chainId !== "0x13881") {
          // If not, suggest them to switch to the Polygon Mumbai network
          try {
            await window.ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: "0x13881", // ChainId of the Polygon Mumbai network
                  chainName: "Polygon Mumbai",
                  nativeCurrency: {
                    name: "MATIC",
                    symbol: "MATIC",
                    decimals: 18,
                  },
                  rpcUrls: ["https://polygon-mumbai-bor-rpc.publicnode.com"],
                  blockExplorerUrls: ["https://mumbai.polygonscan.com//"],
                },
              ],
            });
          } catch (addError) {
            console.log(addError);
          }
        }

        const walletProvider = new ethers.BrowserProvider(window.ethereum);
        const [account] = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        localStorage.removeItem("manuallyDisconnected");
        setIsConnected(true);
        setUserAccount(account);
        setWalletProvider(walletProvider);
        setSigner(signer);
        setContract(
          new ethers.Contract(
            contractArtifact.address,
            contractArtifact.abi,
            await walletProvider.getSigner()
          )
        );
      } catch (error) {
        console.log(error);
      }
    }
  };
  const disconnectWallet = () => {
    if (window.ethereum) {
      localStorage.setItem("manuallyDisconnected", "true");
      setIsConnected(false);
      setUserAccount(null);
    }
  };
  const handleWalletAction = isConnected ? disconnectWallet : connectWallet;
  return (
    <EthereumContext.Provider
      value={{ userAccount, walletProvider, signer, contract }}
    >
      <div
        className="layout-container"
        style={{
          "--gradient-start": gradientStart,
          "--gradient-end": gradientEnd,
        }}
      >
        <header>
          <div className="navbar">
            <Link to="/" className="navbar logo">
              <img className="navbar logo" src={logo} alt="Logo" />
            </Link>

            {/*<h1 className="navbar title">
          <Link to="/Home2" className="navbar home">
            Prompt
            <br />
            Meister
          </Link>
  </h1>*/}
            <h2 className="navbar-home-container">
              <Link to="/" className="navbar home">
                HOME
              </Link>
            </h2>
            <h2 className="navbar-mint-container">
              <Link to="/Mint" className="navbar mint">
                MINT
              </Link>
            </h2>
            <h2 className="navbar-collection-container">
              <Link to="/Collection" className="navbar collection">
                Collection
              </Link>
            </h2>
            <h2 className="navbar-socials-container">
              <Link to="/Socials" className="navbar socials">
                Socials
              </Link>
            </h2>
            <button className="navbar wallet" onClick={handleWalletAction}>
              {isConnected
                ? `${userAccount.substring(0, 6)}...${userAccount.substring(
                    userAccount.length - 4
                  )}`
                : "Wallet"}
            </button>
            {/* Home, Mint, My Collection, Contact Us */}
            {/* Gallery style animation, next collection video based*/}
          </div>
        </header>
        <main>{children}</main>
      </div>
    </EthereumContext.Provider>
  );
}
export default Layout;
